import React, { Component } from "react";
import { Row, Col, Card, Form, Tag } from "antd";
import CurrencyFormat from "react-currency-format";

const FormItem = Form.Item;

class AccumulatedGP extends Component {
  render() {
    const { dataAccumulated } = this.props;

    return (
      <div
        style={{
          borderRadius: 10,
          backgroundColor: "#EFF2F5",
          padding: 15,
          margin: "10px 0",
        }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={12}>
            <div>
              <p style={{ fontSize: 16, fontWeight: "bold" }}>
                Accumulated Gross Profit Trust Branch
              </p>
              <p>Accumulated Gross Profit by Approval BOH</p>
              <p>Accumulated Gross Profit by Approval GM</p>
            </div>
          </Col>
          <Col className="gutter-row" span={12}>
            <div style={{ textAlign: "right" }}>
              <p style={{ fontSize: 16, fontWeight: "bold" }}>
                <CurrencyFormat
                  style={{ width: "100%", margin: "2px" }}
                  value={
                    dataAccumulated && dataAccumulated.totalAccumulated
                      ? dataAccumulated.totalAccumulated
                      : 0
                  }
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  displayType={"text"}
                  prefix={"Rp "}
                />
              </p>
              <p>
                <CurrencyFormat
                  style={{ width: "100%", margin: "2px" }}
                  value={
                    dataAccumulated && dataAccumulated.bohAccumulated
                      ? dataAccumulated.bohAccumulated
                      : 0
                  }
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  displayType={"text"}
                  prefix={"Rp "}
                />
              </p>
              <p>
                <CurrencyFormat
                  style={{ width: "100%", margin: "2px" }}
                  value={
                    dataAccumulated && dataAccumulated.gmAccumulated
                      ? dataAccumulated.gmAccumulated
                      : 0
                  }
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  displayType={"text"}
                  prefix={"Rp "}
                />
              </p>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default AccumulatedGP;



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/Section/AccumulatedGP.js